import { Model } from '../general'

export const Weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const
export type Weekday = (typeof Weekdays)[number]

export type VisualProgram = [number, number, number]

export interface ProgramData {
  weekday: Weekday
  is_enabled: boolean
  start_time: string
  end_time: string
}

export enum Mode {
  Clean = 'clean',
  // Block = 'block', // TODO: Re-enable when blocked mode is implemented
}

export interface Data {
  id: number
  company_id: number
  name?: string
  building_id?: number
  floor_id?: number
  zone_id?: number
  program?: ProgramData[]
  created_by?: number
  created_at?: string
  updated_by?: number
  updated_at?: string
  mode?: Mode
  visual_program?: Record<Weekday, VisualProgram>
}

class Schedule extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }

  get buildingId() {
    return this.data.building_id
  }

  get floorId() {
    return this.data.floor_id
  }

  get zoneId() {
    return this.data.zone_id
  }

  get name() {
    return this.data.name
  }

  get searchText(): string {
    return `${this.name}`
  }

  get program() {
    return this.data.program
  }

  get visualProgram() {
    return this.data.visual_program
  }

  get createdBy() {
    return this.data.created_by || NaN
  }

  get createdAt() {
    return this.data.created_at
  }

  get updatedBy() {
    return this.data.updated_by || NaN
  }

  get updatedAt() {
    return this.data.updated_at
  }

  get mode() {
    return this.data.mode
  }
}

export default Schedule
